import Form from 'app/components/Form';

import {
  getAccounts
} from 'app/services/accounts';

import {
  formatOptions,
  currencyOptions,
  subscriptionOptions
} from 'app/utils/options';

const AccountPricingForm = (props) => {
  const {
    accountPricing,
    onClose,
    onSubmit,
    action
  } = props;

  let header = 'Rates';

  const getAccountOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let params = {
      page,
      per_page: perPage,
      record_id: id
    }

    if (filter) {
      params.filter_model = {
        name: [{
          filterClass: 'text',
          filterType: 'contains',
          value: filter
        }]
      }
    }

    let resp = await getAccounts(params);
    return formatOptions(resp.records);
  }

  const isNewItem = formState => {
    return formState.id === undefined;
  }

  const fields = [
    { name: 'account_id', label: 'Account', type: 'autocomplete', value: accountPricing?.account_id, valueType: 'integer', getOptions: getAccountOptions },
    { name: 'per_image_uploaded_rate', label: 'Per Image Upload', type: 'currency', valueType: 'number', value: accountPricing?.per_image_uploaded_rate, currency: "USD" },
    { name: 'per_image_sold_rate', label: 'Per Image Sold', type: 'currency', valueType: 'number', value: accountPricing?.per_image_sold_rate, currency: "USD" },
    { name: 'per_prepaid_customer_record_rate', label: 'Per Pre-Paid Customer Record', type: 'currency', valueType: 'number', value: accountPricing?.per_prepaid_customer_record_rate, currency: "USD" },
    { name: 'per_event_rate', label: 'Per Event', type: 'currency', valueType: 'number', value: accountPricing?.per_event_rate, currency: "USD" },
    { name: 'per_kiosk_transaction_rate', label: 'Per Kiosk Transaction $', type: 'currency', valueType: 'number', value: accountPricing?.per_kiosk_transaction_rate, currency: "USD" },
    { name: 'per_kiosk_transaction_percentage_rate', label: 'Per Kiosk Transaction %', type: 'currency', valueType: 'number', value: accountPricing?.per_kiosk_transaction_percentage_rate },
    { name: 'per_mobile_transaction_rate', label: 'Per Mobile Transaction $', type: 'currency', valueType: 'number', value: accountPricing?.per_mobile_transaction_rate, currency: "USD" },
    { name: 'per_mobile_transaction_percentage_rate', label: 'Per Mobile Transaction %', type: 'currency', valueType: 'number', value: accountPricing?.per_mobile_transaction_percentage_rate },
    { name: 'per_print_store_sale_rate', label: 'Per Print Store Sale $', type: 'currency', valueType: 'number', value: accountPricing?.per_print_store_sale_rate, currency: "USD" },
    { name: 'per_print_store_sale_percentage_rate', label: 'Per Print Store Sale %', type: 'currency', valueType: 'number', value: accountPricing?.per_print_store_sale_percentage_rate },
    { name: 'subscription', label: 'Subscription', type: 'select', options: subscriptionOptions, valueType: 'integer', value: accountPricing?.subscription },
    { name: 'subscription_rate', label: 'Subscription Rate', type: 'currency', valueType: 'number', value: accountPricing?.subscription_rate },
    { name: 'currency', label: 'Currency', type: 'select', value: accountPricing?.currency, valueType: 'string', options: currencyOptions, hideNoneOption: true},
    { name: 'start_date', label: 'Start Date', type: 'datetime', timeLabel: 'Start Time', value: accountPricing?.start_date, helperText: 'Date the pricing starts', timeHelperText: 'Time the pricing starts', visible: isNewItem },
    { name: 'end_date', label: 'End Date', type: 'datetime', timeLabel: 'End Time', value: accountPricing?.end_date, helperText: 'Date the pricing ends', timeHelperText: 'Time the pricing ends', visible: isNewItem },
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default AccountPricingForm;
